var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEdge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.245 89.269a43.919 43.919 0 01-4.934 2.205 47.688 47.688 0 01-16.806 3.024c-22.15 0-41.446-15.237-41.446-34.79a14.736 14.736 0 017.691-12.785c-20.035.843-25.184 21.72-25.184 33.953 0 34.584 31.873 38.09 38.74 38.09 3.703 0 9.288-1.077 12.64-2.135l.613-.206a60.07 60.07 0 0031.176-24.716 1.87 1.87 0 00-1.294-2.854 1.872 1.872 0 00-1.196.214z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.571 113.086a37.072 37.072 0 01-10.645-9.989A37.787 37.787 0 0152.75 46.924c1.46-.689 3.955-1.934 7.274-1.873a15.143 15.143 0 0112.026 6.085 14.924 14.924 0 012.977 8.735c0-.098 11.45-37.261-37.449-37.261C17.028 22.61.13 42.11.13 59.22A60.925 60.925 0 005.8 85.436 59.917 59.917 0 0079 116.85a35.358 35.358 0 01-29.388-3.745l-.042-.019z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.385 69.758c-.379.492-1.544 1.17-1.544 2.65 0 1.221.795 2.396 2.21 3.384 6.73 4.681 19.421 4.063 19.454 4.063a27.883 27.883 0 0014.17-3.909 28.727 28.727 0 0014.244-24.753c.122-10.49-3.745-17.466-5.308-20.555C104.692 11.235 83.281.075 59.996.075A59.918 59.918 0 00.078 59.15c.225-17.105 17.226-30.92 37.449-30.92 1.638 0 10.982.16 19.66 4.715 7.65 4.016 11.657 8.866 14.442 13.673 2.893 4.995 3.408 11.305 3.408 13.819 0 2.514-1.283 6.24-3.652 9.32z",
    fill: "url(#paint2_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27.566,
    y1: 82.954,
    x2: 111.049,
    y2: 82.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 71.577,
    y1: 46.741,
    x2: 19.434,
    y2: 103.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(92.291 -4.598 16.98) scale(94.8356 201.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEdge);
export default __webpack_public_path__ + "static/media/logo-edge.249be5fbf3f0d4612d21192beaea6fc1.svg";
export { ForwardRef as ReactComponent };